import { createAction } from 'redux-act';

export const updateSettings = createAction('Update settings');
export const updateReceiptSyncs = createAction('Update Receipt Synchronisations');
export const updateConfigurations = createAction('Update Configurations');
export const updateStaticApiToken = createAction('Update Static Api Token');
export const resetStaticApiToken = createAction('Reset Static Api Token');
